(function () {

  function getDrawer() {
    return document.getElementById('om-charms-drawer');
  }

  function getOverlay() {
    let overlay = document.querySelector('.om-charms-overlay');

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'om-charms-overlay';
      document.body.appendChild(overlay);
    }

    return overlay;
  }

  function openDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    const overlay = getOverlay();

    drawer.classList.add('om-charms-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');

    overlay.classList.add('om-charms-overlay--open');

    document.body.classList.add('om-charms-open');

    document.querySelectorAll('.om-charm-trigger').forEach(function(button) {
      button.setAttribute('aria-expanded', 'true');
    });
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const overlay = document.querySelector('.om-charms-overlay');

    if (drawer) {
      drawer.classList.remove('om-charms-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
      overlay.classList.remove('om-charms-overlay--open');
    }

    document.body.classList.remove('om-charms-open');

    document.querySelectorAll('.om-charm-trigger').forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }


  /* =========================
     ABRIR / CERRAR
     ========================= */

  document.addEventListener('click', function(event) {

    const openButton = event.target.closest('.om-charm-trigger');

    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      openDrawer();
      return;
    }


    const closeButton = event.target.closest('.om-charms-drawer__close');

    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      closeDrawer();
      return;
    }


    if (event.target.classList.contains('om-charms-overlay')) {
      closeDrawer();
      return;
    }


    /* =========================
       AÑADIR CHARM AL CARRITO
       ========================= */

    const addButton = event.target.closest('[data-om-charm-add]');

    if (!addButton) return;

    event.preventDefault();
    event.stopPropagation();

    if (addButton.classList.contains('is-loading')) return;

    const variantId = addButton.getAttribute('data-variant-id');

    if (!variantId) return;

    addButton.classList.add('is-loading');
    addButton.disabled = true;

    const originalText = addButton.textContent;

    addButton.textContent = '…';

      /*
     * Añadir el charm usando el sistema AJAX nativo del tema.
     * Creamos temporalmente un formulario compatible con
     * data-product-form-upsell y dejamos que theme.js haga
     * la petición y reconstruya el cart drawer.
     */

    const tempForm = document.createElement('form');

    tempForm.setAttribute('data-product-form-upsell', '');
    tempForm.style.display = 'none';

    const variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.value = variantId;

    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';

    const nativeAddButton = document.createElement('button');
    nativeAddButton.type = 'button';
    nativeAddButton.name = 'add';
    nativeAddButton.setAttribute('data-add-to-cart', '');

    tempForm.appendChild(variantInput);
    tempForm.appendChild(quantityInput);
    tempForm.appendChild(nativeAddButton);

    document.body.appendChild(tempForm);

    nativeAddButton.click();

    addButton.textContent = '✓';

    setTimeout(function() {

      tempForm.remove();

      addButton.textContent = originalText;
      addButton.classList.remove('is-loading');
      addButton.disabled = false;

    }, 1200);

  });


  /* ESC también cierra */

  document.addEventListener('keydown', function(event) {

    if (event.key === 'Escape') {
      closeDrawer();
    }

  });

})();